import { useEffect, useState } from "react";
import Routes from "routes";
import ThemeCustomization from "themes";
import Loader from "components/Loader";
import RTLLayout from "components/RTLLayout";
import ScrollTop from "components/ScrollTop";
import Snackbar from "components/@extended/Snackbar";
import Notistack from "components/third-party/Notistack";
import { IconButton } from "@mui/material";
import { dispatch } from "store";
import { fetchMenu } from "store/reducers/menu";
import { ServerHealthContextProvider } from "contexts/ServerHealthContext";
import { DataContextProvider } from "contexts/DataContext";
import useIsOnline from "hooks/useIsOnline";
import { closeSnackbar, enqueueSnackbar } from "notistack";
import { CloseCircle } from "iconsax-react";
import { WebsocketContextProvider } from "contexts/WebSocketContext";
import "./App.css";
// auth-provider
// import { FirebaseProvider as AuthProvider } from 'contexts/FirebaseContext';
// import { AWSCognitoProvider as AuthProvider } from 'contexts/AWSCognitoContext';
// import { Auth0Provider as AuthProvider } from 'contexts/Auth0Context';

// ==============================|| APP - THEME, ROUTER, LOCAL  ||============================== //

const App = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const { isConnectionLost, isOnline } = useIsOnline();

  useEffect(() => {
    dispatch(fetchMenu()).then(() => {
      setLoading(false);
    });
  }, []);

  if (loading) return <Loader />;

  if (isConnectionLost && isOnline) {
    closeSnackbar();
    enqueueSnackbar("Connection reestablished!", {
      autoHideDuration: 4000,
      variant: "success",
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "center",
      },
      action: (key) => (
        <IconButton
          size="small"
          aria-label="close"
          color="inherit"
          onClick={() => closeSnackbar(key)}
        >
          <CloseCircle fontSize="small" />
        </IconButton>
      ),
    });
  }

  if (!isOnline) {
    closeSnackbar();
    enqueueSnackbar("You are offline. Please check your internet connection.", {
      autoHideDuration: 4000,
      variant: "error",
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "center",
      },
      action: (key) => (
        <IconButton
          size="small"
          aria-label="close"
          color="inherit"
          onClick={() => closeSnackbar(key)}
        >
          <CloseCircle fontSize="small" />
        </IconButton>
      ),
    });
  }

  return (
    <ThemeCustomization>
      <RTLLayout>
        <ScrollTop>
          <>
            <ServerHealthContextProvider>
              <WebsocketContextProvider>
                <DataContextProvider>
                  <Notistack>
                    <Routes />
                    <Snackbar />
                  </Notistack>
                </DataContextProvider>
              </WebsocketContextProvider>
            </ServerHealthContextProvider>
          </>
        </ScrollTop>
      </RTLLayout>
    </ThemeCustomization>
  );
};

export default App;
